module.exports = __webpack_public_path__ + "img/lpbody-2.dd324e86.jpg";